// IMPORT PACKAGE REFERENCES
import { AnyAction, combineReducers } from 'redux';

// IMPORT REDUCERS
import { UserReducer } from './UserReducer';
import { RouteReducer } from './RouteReducer';
import { ProductReducer } from './ProductReducer';
import { CategoryReducer } from './CategoryReducer';
import { GroupReducer } from './GroupReducer';
import { MustSellReducer } from './MustSellReducer';
import { TargetGroupReducer } from './TargetGroupReducer';
import { CampaignReducer } from './CampaignReducer';
import { FileDownloadReducer } from './FileDownloadReducer';
import { FormsReducer } from './FormsReducer';
import { FormReducer } from './FormReducer';
import { CallScheduleReducer } from './CallScheduleReducer';
import { OrderReducer } from './OrderReducer';
import { ResourceImageManagerReducer } from './ResourceImageManagerReducer';
import { VersionReducer } from './VersionReducer';
import { OutOfStockReducer } from './OutOfStockReducer';
import { DistributorReducer } from './DistributorReducer';
import { HierarchyReducer } from './HierarchyReducer';
import { FeatureFlagsReducer } from './FeatureFlagsReducer';
import { ObjectivesReducer } from './ObjectivesReducer';
import { CustomerFlagReducer } from './CustomerFlagReducer';
import { PriceListsReducer } from './PriceListsReducer';
import { UserRoleReducer } from './UserRoleReducer';
import { CodedValueReducer } from './CodedValueReducer';
import { DashboardLayoutReducer } from './DashboardLayoutReducer';

import { VERSION_UPDATE } from '../constants/action-types';
import { FixMeLater } from 'types/FixMeLaterType';

const AppReducer = combineReducers({
  VersionReducer,
  UserReducer,
  RouteReducer,
  ProductReducer,
  CategoryReducer,
  GroupReducer,
  MustSellReducer,
  TargetGroupReducer,
  CampaignReducer,
  FileDownloadReducer,
  FormsReducer,
  FormReducer,
  CallScheduleReducer,
  OrderReducer,
  ResourceImageManagerReducer,
  OutOfStockReducer,
  DistributorReducer,
  HierarchyReducer,
  FeatureFlagsReducer,
  ObjectivesReducer,
  CustomerFlagReducer,
  PriceListsReducer,
  UserRoleReducer,
  CodedValueReducer,
  DashboardLayoutReducer
});

export const RootReducer = (state: FixMeLater, action: AnyAction) => {
  if (action.type === VERSION_UPDATE) {
    state = {}
  }

  return AppReducer(state, action)
}

export type RootState = ReturnType<typeof RootReducer>
